import { Info, Users, FileText, Wallet, Car, Gem } from 'lucide-react';

export const productIconMap = { Wallet, Car, Gem };

export const aboutSubpages = [
  { title: 'Biz kimik?', slug: 'biz-kimik', description: 'İnkişafa Dəstək Kreditləri BOKT haqqında ümumi məlumat', icon: Info },
  { title: 'Rəhbərlik', slug: 'rehberlik', description: 'İdarəetmə komandası', icon: Users },
  { title: 'Hesabatlar', slug: 'hesabatlar', description: 'İllik maliyyə hesabatları', icon: FileText }
];

export const navigation = [
  { name: 'Əsas səhifə', href: '/' },
  { name: 'Haqqımızda', href: '/haqqimizda', hasDropdown: 'about' },
  { name: 'Məhsullar', href: '/mehsullar', hasDropdown: 'products' },
  { name: 'Kredit kalkulyatoru', href: '/kalkulator' },
  { name: 'Əlaqə', href: '/elaqe' }
];
